(function ($) {
  DJ.addBehavior('headerSticky', '.header', {
    attach: function () {
      const header = this;
      const tileCreationMobile = document.querySelector('.tile-creation-mobile');
      const sectionNavigationMobileBtn = document.querySelector('.section-navigation__mobile-btn');
      const stickyMenuItemNewMessage = document.querySelector('.sticky-menu__item--new-message');
      const footer = document.querySelector('.footer');

      // If one of the button on the page - add class to the footer.
      if ((tileCreationMobile || sectionNavigationMobileBtn || stickyMenuItemNewMessage)
        && footer) {
        footer.classList.add('footer--space-for-buttons');
      }

      $(document).once().on('ajaxError', function (event, jqxhr, settings, thrownError) {
        const errorMessage = document.createElement('div');
        errorMessage.classList.add('messages', 'messages--error', 'file-upload-js-error', 'large-file-error');
        errorMessage.innerText = Drupal.t('Le fichier est trop important : la taille maximale autorisée est de 20 Mo');
        const block = document.querySelector('.js-form-type-brio-media-managed-file');
        const blockAjouter = document.querySelector('.add-resource-popup');
        if (block) {
          block.append(errorMessage);
        } else if (blockAjouter) {
          const boxInput = blockAjouter.querySelector('.js-form-item .js-form-file');
          const fakeInput = blockAjouter.querySelector('.js-form-item .jcf-fake-input');
          boxInput.value = '';
          fakeInput.remove();
          errorMessage.innerText = Drupal.t('File is too large.');
          blockAjouter.querySelector('.js-form-type-brio-resource-managed-file').append(errorMessage);
        }
      });

      /**
       * Add/remove sticky class depending on scrollTop.
       */
      const toggleSticky = () => {
        const st = window.pageYOffset || document.documentElement.scrollTop;

        if (st >= 188) {
          header.style.height = `${header.offsetHeight}px`;
          header.classList.add('header--sticky-view');
        } else {
          header.style.height = 'auto';
          header.classList.remove('header--sticky-view');
        }
      };

      toggleSticky();

      window.addEventListener('scroll', () => {
        toggleSticky();
      }, false);
    }
  });
})(jQuery);
